<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        (click)="goBack()"
        defaultHref="/home"
        icon="chevron-back-outline"
        class="primary-icon-color"
      ></ion-back-button>
    </ion-buttons>
    <ion-title class="fs-5 font600 ion-no-padding title-text-color"
      >{{"page_status.generic_error.back" | translate}}</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-grid class="ion-no-padding" style="height: 100%">
  <ion-row
    class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
    style="height: 100%; flex-direction: column"
  >
    <ion-card class="ion-bg-transparent no-shadow ion-padding ion-text-center">
      <custom-icon
        [iconName]="image"
        [width]="250"
        [height]="250"
        class="ion-padding"
        colorClass="modalIcon"
        style="max-width: 350px; width: 100%; margin: auto"
      ></custom-icon>
      <ion-text color="dark">
        <h2 class="font700">{{"page_status.generic_error.whoops" | translate}}</h2>
        <p class="fs-3 font500">{{"toast_message.something_went_wrong" | translate}}</p>
        <!-- <p>Check your Connection</p> -->
      </ion-text>
      <ion-button
        (click)="reloadCurrentRoute()"
        class="ion-margin"
        expand="block"
        color="primary"
        fill="solid"
      >
      {{"page_status.generic_error.try_again" | translate}}
      </ion-button>
    </ion-card>
  </ion-row>
</ion-grid>
<support-widget *ngIf="partnerPid !== 'hom'"></support-widget>
